module.exports = __webpack_public_path__ + "img/undo-alt.40d09bec.svg";